import { isEmpty, isNil } from 'lodash';
import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBDefaultError } from '@shared/components/wrapper';
import { CardEntityError } from '@shared/scenes/entity/create/hooks/useFormErrors';
import { ColorThemeContext } from '@shared/styles';

export function FormErrors({ errors }: { errors: CardEntityError[] }) {
  const formErrors = errors.filter(error => isNil(error.componentId));
  const colors = useContext(ColorThemeContext);

  if (isEmpty(formErrors)) {
    return null;
  }

  return (
    <View style={{ width: '100%' }}>
      {formErrors.map((error, index) => (
        <MBDefaultError
          key={`${error.description}-${index}`}
          message={error.description ?? ''}
          isRounded={false}
          marginBottom={0}
          style={{ borderBottomWidth: 1, borderBottomColor: colors.input.borderInactive }}
        />
      ))}
    </View>
  );
}
